import { render, staticRenderFns } from "./happiness-level.view.vue?vue&type=template&id=2634b217&scoped=true&"
import script from "./happiness-level.view.vue?vue&type=script&lang=ts&"
export * from "./happiness-level.view.vue?vue&type=script&lang=ts&"
import style0 from "./happiness-level.view.vue?vue&type=style&index=0&id=2634b217&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634b217",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VRow})
